import { render } from "./PickupOrder.vue?vue&type=template&id=42585122"
import script from "./PickupOrder.vue?vue&type=script&lang=js"
export * from "./PickupOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__